(function () {
    'use strict';

    angular.module('app')
        .factory('Estadisticas', Estadisticas);

    /* @ngInject */
    function Estadisticas($resource) {
        return $resource('api/admin/estadisticas', {}, {

            'getEstadisticas': {

                method: 'GET',
                url: 'api/admin/estadisticas/getEstadisticas'

            }

        });
    }
})();
